var map = {
	"./flag-en.png": 895,
	"./flag-lt.png": 896
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1257;



//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/flag\-.*\.png$
// module id = 1257
// module chunks = 0